module.exports = __webpack_public_path__ + "static/img/badlands.f7b52eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/badlands.jpg
// module id = nZ5y
// module chunks = 1